import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { LogManagementListFeatureGate } from '../Guards/LogManagementListFeatureGate'
import { LogManagementList } from '../Components/Organisms/LogManagementList/LogManagementList'

/**
 * Routed log management (log file status and control) page.
 */
@Route(RouteID.LOG_MANAGEMENT)
export class LogManagementListPage extends Component {
    /**
     * Renders the log management page content tree.
     *
     * @returns Log management page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.LOG_MANAGEMENT}>
                <LogManagementListFeatureGate>
                    <LanguageContextProvider>
                        <LogManagementList />
                    </LanguageContextProvider>
                </LogManagementListFeatureGate>
            </RouteGuard>
        )
    }
}
